// extracted by mini-css-extract-plugin
export default {"CarMarks":"CarMarks_CarMarks__sVeD8","CarMarks__new":"CarMarks_CarMarks__new__qq8nx","CarMarks__table":"CarMarks_CarMarks__table__fE5GJ"};